var View = require("./linedash-view.js");

$(function () {
  var rootElement = $(".linedash");
  new View(rootElement);
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/main.js
 ** module id = 0
 ** module chunks = 0
 **/